import PropTypes from 'prop-types';
import React from 'react';

import Modal from '../modals/Modal';

import styles from '../../styles/layouts/main.module.css';

const propTypes = {
    children: PropTypes.node.isRequired,
};

function MainLayout({ children }) {
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.content}>{children}</div>
            </div>
            <Modal />
        </div>
    );
}

MainLayout.propTypes = propTypes;

export default MainLayout;
